import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { format } from "date-fns";
import { ReactComponent as PrevYear } from "../../../../../assets/svg/header-super-prev-btn.svg";
import { ReactComponent as NextYear } from "../../../../../assets/svg/header-super-next-btn.svg";
import { ReactComponent as PrevMonth } from "../../../../../assets/svg/header-prev-btn.svg";
import { ReactComponent as NextMonth } from "../../../../../assets/svg/header-next-btn.svg";
import { useSelector } from "react-redux";
import { getComponents } from "../helpers";
import { AppState } from "../../../../../stateManager/store";
import update from "immutability-helper";
import moment from "moment";


const DatePickerPropertyPanel = ((props: any) => {
    const { value, keyVal, setConfigValues, dateRange, configValues, handleChange, where, setFromKeyDateErrorVal, setToKeyDateErrorVal, setFromKeyDateNumberErrorVal, setToKeyDateNumberErrorVal } = props;

    const { selectedElementId } = useSelector(
        (state: AppState) => state.formJson
    );
    const { components } = getComponents();
    const component = components[selectedElementId] || {};
    const properties: any = component?.properties?.config ? component.properties.config : {};
    const { selectSpecificDateFrom = "01/01/1800", selectSpecificDateEnd = "31/12/2150" } = properties;

    const [fromDateError, setFromDateError] = useState<boolean>(false);
    const [toDateError, setToDateError] = useState<boolean>(false);

    const parseDate = (dateStr: string) => new Date(Number(dateStr.slice(6, 10)), Number(dateStr.slice(3, 5)) - 1, Number(dateStr.slice(0, 2)));
    const getDayClassName = (date: Date) => {
        const currentDate = new Date();

        if (keyVal === "selectSpecificDateFrom" && parseDate(selectSpecificDateFrom) && date.toDateString() === parseDate(selectSpecificDateFrom).toDateString()) {
            return 'selected-date'
        }
        if (keyVal === "selectSpecificDateEnd" && parseDate(selectSpecificDateEnd) && date.toDateString() === parseDate(selectSpecificDateEnd).toDateString()) {
            return 'selected-date'
        }
        if (date.toDateString() === currentDate.toDateString()) {
            return 'current-date';
        }
        return '';
    };

    const formatWeekDay = (day: string) => {
        return day.slice(0, 3);
    };

    useEffect(() => {
       if (keyVal === "selectSpecificDateFrom" && moment(moment(dateRange.startDate).set({ hour: 0, minute: 0, second: 0 })).toDate() >= moment(moment(dateRange.endDate).set({ hour: 23, minute: 59, second: 59 })).toDate()) {
        setFromDateError(true);
       } else {
        setFromDateError(false);
       }
       if (keyVal === "selectSpecificDateEnd" && moment(moment(dateRange.startDate).set({ hour: 0, minute: 0, second: 0 })).toDate() >= moment(moment(dateRange.endDate).set({ hour: 23, minute: 59, second: 59 })).toDate()) {
        setToDateError(true);
       } else {
        setToDateError(false);
       }
    }, [props]);

    let [day, month, year]: string[] = [];
    value && ([day, month, year] = value.split("/"));
    let dateValue: Date;

    return (
        <div className="panel_date_picker__input_field" data-test-id={keyVal}>
            <div className="panel_date_picker">
                <DatePicker
                    selected={value ? new Date(Number(year), Number(month) - 1, Number(day)) : null}
                    onCalendarClose={() => {
                        setTimeout(() => {
                            const dateStartInput = document.querySelectorAll('.react-datepicker__input-container > input')[0] as HTMLInputElement;
                            const dateEndInput = document.querySelectorAll('.react-datepicker__input-container > input')[1] as HTMLInputElement;
                            if (dateStartInput) {
                                dateStartInput.blur();
                            } if (dateEndInput) {
                                dateEndInput.blur();
                            }
                        }, 300);
                    }}
                    onChange={(value: any) => {
                        if (!value) {
                            const updatedConfig = update(configValues, {[keyVal]: { $set: "" }});
                            setConfigValues(updatedConfig, () => handleChange(where, keyVal === "selectSpecificDateFrom" ? "01/01/1800" : keyVal === "selectSpecificDateEnd" ? "31/12/2150" : ""));
                            return;
                        }
                        dateValue = value;
                        value = format(new Date(value), "dd/MM/yyyy");

                        if (keyVal === "selectSpecificDateFrom" && dateRange.startDate && dateRange.endDate) {
                            if (moment(moment(new Date(dateValue)).set({ hour: 0, minute: 0, second: 0 })).toDate() >= moment(moment(dateRange.endDate).set({ hour: 23, minute: 59, second: 59 })).toDate()) {
                                setFromDateError(true);
                            } else {
                                setFromDateError(false);
                                setToKeyDateErrorVal(false);
                                setToKeyDateNumberErrorVal(false);
                            }
                        }

                        if (keyVal === "selectSpecificDateEnd" && dateRange.startDate && dateRange.endDate) {
                            if (moment(moment(new Date(dateValue)).set({ hour: 0, minute: 0, second: 1 })).toDate() <= moment(moment(dateRange.startDate).set({ hour: 0, minute: 0, second: 0 })).toDate()) {
                                setToDateError(true);
                            } else {
                                setToDateError(false);
                                setFromKeyDateErrorVal(false);
                                setFromKeyDateNumberErrorVal(false);
                            }
                        }

                        const updatedConfig = update(configValues, {
                            [keyVal]: { $set: value },
                        });
                        setConfigValues(updatedConfig, () =>
                            handleChange(where, value)
                        );
                    }}
                    onChangeRaw={(event) => {
                        if (!event.target || typeof event.target.value !== "string") return;
                        const input = event.target as HTMLInputElement;
                        let cursorPos = input.selectionStart ?? 0;
                        let value = input.value.replace(/[^\d/]/g, '');

                        value = value.replace(/\/{2,}/g, '/'); 
                        const parts = value.split('/');
                        if (parts.length > 3) {
                            value = parts.slice(0, 3).join('/');
                        }
                        if (parts[1]?.length === 4) {
                            value = parts[0] + "/" + parts[1];
                            return
                        }
                        if(parts[1]?.length > 2 && value.length == 10){
                            value = parts[0]+ "/" + parts[1].slice(0,2) + "/" + parts[1].slice(2) + (parts[2] || '')
                        }

                        if (value.length > 2 && value[2] !== '/' && parts.length < 2) {
                            value = `${value.slice(0, 2)}/${value.slice(2)}`;
                            if (cursorPos === 3) cursorPos++;
                        }
                        if (value.length > 5 && value[5] !== '/' && parts.length < 3) {
                            value = `${value.slice(0, 5)}/${value.slice(5)}`;
                            if (cursorPos === 6) cursorPos++;
                        }
                        if (value.length > 10) {
                            value = value.slice(0, 10);
                        }
                        if (value.length === 10) {
                            const [dd, mm, yyyy] = value.split('/').map(Number);
                            const enteredDate = new Date(yyyy, mm - 1, dd);
                            const minDate = new Date(1800, 0, 1);
                            const maxDate = new Date(2150, 11, 31);
                    
                            if (enteredDate < minDate) {
                                value = "01/01/1800";
                            } else if (enteredDate > maxDate) {
                                value = "31/12/2150";
                            }
                        }
                        input.value = value;
                        input.setSelectionRange(cursorPos, cursorPos);
                    }}
                    
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                    minDate={new Date("1800-01-01")}
                    maxDate={new Date("2150-12-31")}
                    renderCustomHeader={({
                        date,
                        changeYear,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                    }) => (
                        <div className="custom-header">
                            <button type="button" onClick={() => changeYear(date.getFullYear() - 1)} className="year-nav" >
                                <PrevYear />
                            </button>
                            <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="month-nav" >
                                <PrevMonth />
                            </button>
                            <span className="month-year">
                                {date.toLocaleString("default", { month: "short" })} {date.getFullYear()}
                            </span>
                            <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="month-nav" >
                                <NextMonth />
                            </button>
                            <button type="button" onClick={() => changeYear(date.getFullYear() + 1)} className="year-nav" >
                                <NextYear />
                            </button>
                        </div>
                    )}
                    dayClassName={getDayClassName}
                    formatWeekDay={formatWeekDay}
                />
            </div>
            <div>
                {toDateError && keyVal === "selectSpecificDateEnd" && (
                    <p data-test-id="validation_error_message" className="error_message__date_picker">
                        Select on/after from date.
                    </p>
                )}
                {fromDateError && keyVal === "selectSpecificDateFrom" && (
                    <p data-test-id="validation_error_message" className="error_message__date_picker">
                        Select on/before end date.
                    </p>
                )}
            </div>
        </div>
    )
})
export default DatePickerPropertyPanel;